import { Link } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth/authContext';
import { routePaths } from '@/app/router/routePaths';
import { Button } from '@/shared/ui/Button';

export function AppHeader() {
  const { session, signOut } = useAuth();

  return (
    <header className="border-line bg-surface/80 sticky top-0 z-10 border-b backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <Link to={routePaths.home} className="flex flex-col leading-tight">
          <span className="text-brand text-[0.65rem] font-semibold tracking-widest uppercase">
            FF Ratekau
          </span>
          <span className="text-base font-bold tracking-tight">Dart-Cup</span>
        </Link>

        {session.status === 'authenticated' ? (
          <div className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <p className="text-sm font-medium">{session.account.displayName ?? 'Angemeldet'}</p>
              {session.account.role === 'admin' && (
                <p className="text-brand text-xs font-semibold tracking-wide uppercase">
                  Turnierleitung
                </p>
              )}
            </div>
            {session.account.role === 'admin' && (
              <Link to={routePaths.admin.root}>
                <Button variant="secondary" size="md">
                  Adminbereich
                </Button>
              </Link>
            )}
            <Button
              variant="ghost"
              size="md"
              onClick={() => {
                void signOut();
              }}
            >
              Abmelden
            </Button>
          </div>
        ) : (
          session.status === 'anonymous' && (
            <Link to={routePaths.login}>
              <Button size="md">Anmelden</Button>
            </Link>
          )
        )}
      </div>
    </header>
  );
}
